<template>
  <section v-if="product">
    <div class="section-head pt-16">
      <h2>{{ product.title }}</h2>
    </div>
    <div class="product-ov__product">
      <div v-if="0 < imgArray.length" class="product-ov__ímages">
        <h2 class="mb-4">Product Gallery</h2>
        <UiDevider class="mb-4" />
        <div class="product-ov__gallery">
          <img
            class="product-ov__ímg"
            v-for="(image, i) in imgArray"
            :key="i"
            :src="image"
            @click="imgIndex = i"
          />
        </div>
        <vue-gallery-slideshow
          :images="imgArray"
          :index="imgIndex"
          @close="imgIndex = null"
        ></vue-gallery-slideshow>
      </div>
      <UiDevider class="mt-12 block sm:hidden" />
      <div class="product-ov__infos">
        <h2 class="mb-4">Produkt-Infos</h2>
        <UiDevider />
        <p class="mt-4">{{ product.long_description }}</p>

        <div
          v-if="product.important_note"
          class="flex justify-center mt-4 text-2xl px-4"
        >
          <div
            class="text-white border-0 py-4 rounded relative mb-4 bg-red-800 w-full"
          >
            <span class="hidden sm:flex product-ov__attention-icon sm:pl-4">
              <fa-icon :icon="['fas', 'exclamation']" size="lg" />
            </span>
            <span class="ml-2">
              <b class="capitalize">Important!</b>
              {{ product.important_note }}
            </span>
          </div>
        </div>

        <div class="product-ov__price">
          <span v-if="dollarPrice">{{ dollarPrice }}$</span>
          <span>{{ product.eur_price }}€</span>
        </div>
        <div v-if="0 < product.options.length" class="product-ov__features">
          <h3>Options</h3>
          <div v-for="(feature, i) in product.options" :key="i">
            <div class="product-ov__features-row">
              <span>{{ feature.name }}:</span>
              <span>{{ feature.options }}</span>
            </div>
          </div>
        </div>
        <div class="product-ov__table"></div>

        <button class="product-ov__buy" @click="openCall">
          Place an order
          <div class="product-ov__buy--horizontal"></div>
          <div class="product-ov__buy--vertical"></div>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow'
import { specificProduct } from '@/services/api/product.js'
import client from '@/services/client'

export default {
  components: {
    VueGallerySlideshow
  },
  data() {
    return {
      product: null,
      imgArray: [],
      imgIndex: null,
      dollarPrice: ''
    }
  },
  methods: {
    openCall() {
      window.open('tel:+4917622769157')
    }
  },
  async mounted() {
    await specificProduct(this.$route.params.id).then(async response => {
      const resProduct = response.product
      this.product = resProduct
      if (0 < resProduct.images.length) {
        resProduct.images.forEach(img => {
          this.imgArray.push(img.image_path)
        })
      }
      await client.get('exchange').then(data => {
        const dollarPrice = parseFloat(data)
        const eurPrice = parseFloat(this.product.eur_price)
        this.dollarPrice = (dollarPrice * eurPrice).toFixed(2)
      })
    })
  }
}
</script>

<style lang="sass">
.product-ov
    &__attention-icon
      opacity: 0.5
      @apply absolute w-full top-0 left-0 flex items-center ml-3 h-full
    &__product
        @apply flex flex-col-reverse
    &__ímages
        @apply w-full flex flex-col px-4 mt-8
        h1
            @apply my-6
    &__gallery
        @apply flex flex-wrap justify-center
    &__ímg
        background-size: cover
        cursor: pointer
        margin: 5px
        border: 1px solid #fff
        @apply w-40 h-40 rounded-md object-contain cursor-pointer
    &__infos
        @apply w-full
    &__price
        @apply flex justify-evenly mt-4
        span
            transition: all 0.2s ease-in
            @apply border border-red-800 px-4 py-2 leading-normal rounded-md cursor-pointer
            &:hover
              color: $accent-color
              @apply border-white bg-white
    &__features
        @apply my-4
        h3
            @apply my-4 text-4xl
        &-row
            @apply inline-grid
            span:first-of-type
              @apply underline
    &__buy
        background: $accent-color
        @apply w-auto px-6 mt-8 pb-1 border-white border rounded-md
        --offset: 10px
        --border-size: 2px
        position: relative
        padding: 0.5em 1.0em
        appearance: none
        border: 0
        background: transparent
        color: #fff
        text-transform: uppercase
        letter-spacing: .1em
        outline: none
        cursor: pointer
        font-weight: bold
        border-radius: 0
        box-shadow: inset 0 0 0 var(--border-size) currentcolor
        transition: background .8s ease
        &:hover
            background: rgba(100, 0, 0, .03)
        &--horizontal,
        &--vertical
            position: absolute
            top: var(--horizontal-offset, 0)
            right: var(--vertical-offset, 0)
            bottom: var(--horizontal-offset, 0)
            left: var(--vertical-offset, 0)
            transition: transform .8s ease
            will-change: transform
            &::before
                content: ''
                position: absolute
                border: inherit
        &--horizontal
            --vertical-offset: calc(var(--offset) * -1)
            border-top: var(--border-size) solid currentcolor
            border-bottom: var(--border-size) solid currentcolor
            &::before
                top: calc(var(--vertical-offset) - var(--border-size))
                bottom: calc(var(--vertical-offset) - var(--border-size))
                left: calc(var(--vertical-offset) * -1)
                right: calc(var(--vertical-offset) * -1)
        &:hover &--horizontal
            transform: scaleX(0)
        &--vertical
            --horizontal-offset: calc(var(--offset) * -1)
            border-left: var(--border-size) solid currentcolor
            border-right: var(--border-size) solid currentcolor
            &::before
                top: calc(var(--horizontal-offset) * -1)
                bottom: calc(var(--horizontal-offset) * -1)
                left: calc(var(--horizontal-offset) - var(--border-size))
                right: calc(var(--horizontal-offset) - var(--border-size))
        &:hover &--vertical
            transform: scaleY(0)

@screen sm
    .product-ov
        &__product
            @apply flex-row
        &__ímages
            @apply w-1/2 mt-0
        &__infos
            @apply w-1/2
</style>
